module.exports = __webpack_public_path__ + "static/media/intro.45ae86c1.mp3";